import { useEffect, useRef, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import setLoadingState from "../../../functions/setLoadingState";
import Cities from "./Cities";
import style from "./FilterCity.module.css";
import searchCity from "./functions/searchCity";

function FilterCity({ setCity }) {
  const [filterCities, setFilterCitis] = useState([]);
  const ref = useRef(false);
  const [loading, setLoading] = useState([false, false]);
  const [key, seyKey] = useState("");
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      if (key.length < 3) return;
      const timeoutId = setTimeout(() => {
        searchCity(
          key,
          value =>
            setLoading(cur =>
              setLoadingState({ array: cur, index: 0, value: value })
            ),
          data => setFilterCitis(data)
        );
      }, 800);

      return () => clearTimeout(timeoutId);
    } else didMount.current = true;
  }, [key]);

  return (
    <div className={style.box}>
      <div className={"my-4 d-flex " + style.input}>
        <input
          type="text"
          value={key}
          onChange={e => seyKey(e.target.value)}
          ref={ref}
          placeholder="نام شهر (حداقل سه کاراکتر) ..."
        />
        <div className="d-flex justify-content-center align-items-center">
          <RiSearchLine />
        </div>
      </div>
      <Cities
        cities={filterCities}
        loading={loading[0]}
        setLoading={value =>
          setLoading(cur =>
            setLoadingState({ array: cur, index: 0, value: value })
          )
        }
        set={data => {
          setCity(data);
          setFilterCitis(() => []);
          seyKey(() => "");
        }}
      />
    </div>
  );
}

export default FilterCity;
